import React from "react";
import PropTypes from "prop-types";
import { StatusGlyph } from "../kit";
import { useLocales } from "../../core/i18n";

const LABEL =
	"font-mono text-pp-label text-pp-on-slab-muted uppercase block mb-2 tracking-pp-label";

/** One labelled fact on the slab. */
const Fact = ({ label, children, valueClassName = "font-mono text-pp-on-slab text-sm" }) => (
	<div>
		<span className={LABEL}>{label}</span>
		<span className={valueClassName}>{children}</span>
	</div>
);

/**
 * The practical facts beside the contact actions: response time, timezone
 * and, only while `openToWork`, a live availability line.
 */
const ContactFacts = ({ openToWork }) => {
	const { t } = useLocales();
	return (
		<div className="lg:col-span-4 lg:border-l border-pp-on-slab-rule lg:pl-12 flex flex-col gap-5">
			<Fact label={t("contact.response")}>{t("contact.responseTime")}</Fact>
			<Fact label={t("contact.timezone")}>{t("contact.timezoneValue")}</Fact>
			{openToWork && (
				<Fact
					label={t("contact.availabilityStatus")}
					valueClassName="font-mono text-pp-accent text-sm flex items-center gap-2"
				>
					<StatusGlyph variant="live" pulse />
					{t("contact.availabilityValue")}
				</Fact>
			)}
		</div>
	);
};

Fact.propTypes = {
	label: PropTypes.node.isRequired,
	children: PropTypes.node,
	valueClassName: PropTypes.string,
};
ContactFacts.propTypes = { openToWork: PropTypes.bool.isRequired };

export default ContactFacts;
